// libs
import get from 'lodash/get';

const DEFAULT = {
  enabled: false,
  vertical: 'www.nykaafashion.com',
  source: 'nf-web',
  eventApiInterval: 20000,
};

interface IAddPlatformImpression {
  enabled: boolean;
  vertical: string;
  source: string;
  eventApiInterval: number;
}

export const mapConfigToState = (configData: IAddPlatformImpression) => {
  return {
    enabled: get(configData, 'enabled', DEFAULT.enabled),
    vertical: get(configData, 'vertical', DEFAULT.vertical),
    source: get(configData, 'source', DEFAULT.source),
    eventApiInterval: get(configData, 'eventApiInterval', DEFAULT.eventApiInterval),
  };
};
